import React, { useState } from "react";
import "./ContactTakingPopup.css";

const ContactTakingPopup = ({ onClose, onSubmit }) => {
  const [contact, setContact] = useState("");
  const [error, setError] = useState("");

  // Function to handle input change
  const handleChange = (e) => {
    setContact(e.target.value);
    setError(""); // Clear error when user types
  };

  // Function to validate and submit contact
  const handleSubmit = (e) => {
    e.preventDefault();

    // Basic validation: must be either a phone number or a valid email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/;

    if (!emailRegex.test(contact) && !phoneRegex.test(contact)) {
      setError("Please enter a valid email or 10-digit phone number.");
      return;
    }

    // Pass contact to parent component or backend
    onSubmit(contact);

    // Close the popup after submission
    onClose();
  };

  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <div className="popup-header">
            <h2>Stay Connected!</h2>
            <h2 className="close" onClick={onClose}><i class="ri-close-line"></i></h2>
        </div>
        <p>Enter your email to receive updates and personalized insights.</p>
        <img src="https://cdni.iconscout.com/illustration/premium/thumb/male-pandit-working-on-laptop-illustration-download-in-svg-png-gif-file-formats--indian-pack-people-illustrations-2319301.png?f=webp" alt="Contact" />
        <form className="contact-frm" onSubmit={handleSubmit}>
          <label htmlFor="contact">Please enter your email here: </label>
          <input
            type="text"
            id="contact"
            name="contact"
            value={contact}
            onChange={handleChange}
            placeholder="krishna@gmail.com"
            required
          />
          {error && <p className="error-text">{error}</p>}

          <button type="submit" className="">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default ContactTakingPopup;
